import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Checkbox from '@material-ui/core/Checkbox';
import Controls from './controls';

const styles = theme => ({
  form: {
    display: 'flex', flexDirection: 'column',
    margin: 'auto', width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class View extends React.Component {
  state = {
    open: false, menu: [], updateMenuControls: []
  };

  componentDidMount() {
    this.getMenucontrol();
  }

  getMenus() {
    let context = this;
    context.setState({ load: true, message: 'Getting Executive Controls!!!' });
    $.ajax({
      type: 'POST', data: { 'role_id': this.props.id }, 
      url: Server() + 'executivemenu/get.php',
      success: function (data) {
        let menu = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            if (c.type == 'control') {
              menu.push(c)
            }
          })
          context.getMenucontrol(menu);
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function (e) {
        context.setState({ load: false });
      }
    });
  }

  getMenucontrol(menu) {
    let context = this;
    $.ajax({
      type: 'POST', data: { 'id': this.props.id },
      url: Server() + 'executivemenu/getcontrols.php',
      success: function(data) {
        let menus = [];
        try {
          data = JSON.parse(data);
          menu.map((c) => {
            let view = 0; let add = 0; let edit = 0; let cancel = 0; let exports = 0;
            data.map((v) => {
              if (c.referId == v.menu_id && v.sub_menu_name == 'add') { add = v.control; }
              if (c.referId == v.menu_id && v.sub_menu_name == 'view') { view = v.control; }
              if (c.referId == v.menu_id && v.sub_menu_name == 'edit') { edit = v.control; }
              if (c.referId == v.menu_id && v.sub_menu_name == 'cancel') { cancel = v.control; }
              if (c.referId == v.menu_id && v.sub_menu_name == 'exports') { exports = v.control; }
            })
            if (view == '0' || view == 0) { view = false; } else { view = true; }
            if (add == '0' || add == 0) { add = false; } else { add = true; }
            if (edit == '0' || edit == 0) { edit = false; } else { edit = true; }
            if (cancel == '0' || cancel == 0) { cancel = false; } else { cancel = true; }
            if (exports == '0' || exports == 0) { exports = false; } else { exports = true; }
            menus.push({ 'name': c.name, 'referId': c.referId, view, add, edit, cancel, exports })
          })
          context.setState({ menu: menus, open: true })
        } catch (error) {
        }
      },
      error: function(e) {
        context.setState({ load: false });
      }
    });
  }

  handleChangeCheck = (controls, menuId) => event => {
    let updateMenuControls = this.state.updateMenuControls;
    let value = 0;
    updateMenuControls.map((c) => {
      if (c.controls == controls && menuId == c.menuId) {
        c.checked = event.target.checked;
        value = 1;
      }
    })
    if (value == 0) {
      updateMenuControls.push({ controls, menuId, checked: event.target.checked })
    }
    this.setState({ updateMenuControls })
  }

  submit() {
    let context = this;
    let updateMenuControls = this.state.updateMenuControls;
    updateMenuControls = JSON.stringify(updateMenuControls);
    $.ajax({
      type: 'POST', data: { updateMenuControls, 'role_id': this.props.id }, 
      url: Server() + 'executivemenu/updatesubmenucontrols.php',
      success: function (data) {
        if (data == 1) {
          context.setState({ open: false, updateMenuControls: [] })
        }
      },
      error: function (e) {
        context.setState({ load: false });
      }
    });
  }


  render() {
    const { classes, data } = this.props;
    let i = 0;
    let checkOption;
    let subMenu = [
      { key: 'Branch' }, { key: 'Model' }, { key: 'Assembly' }, { key: 'Group' },
      { key: 'Category' }, { key: 'Brand' }, { key: 'Conbo' }, { key: 'Mode' }
    ]
    return (
      <div>
        <u onClick={this.getMenus.bind(this)} style={{color: 'blue'}}>Edit</u>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
            open={this.state.open} onClose={ () => { this.setState({ open: false }) }}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Sub Menu Controls</DialogTitle>
            <DialogContent>
              <table id="table" width="100%">
                <tr>
                  <th id="th" style={{width: '20%'}}><center>Menu</center></th>
                  <th id="th" style={{width: '7%'}}><center>View</center></th>
                  <th id="th" style={{width: '7%'}}><center>Add</center></th>
                  <th id="th" style={{width: '7%'}}><center>Edit</center></th>
                  <th id="th" style={{width: '7%'}}><center>Cancel</center></th>
                  <th id="th" style={{width: '7%'}}><center>Export</center></th>
                </tr>
                {
                  this.state.menu.map((c) => {
                    return (
                      <tr>
                        <td><center>{c.name}</center></td>
                        <td><center><Checkbox onClick={this.handleChangeCheck('view', c.referId)} defaultChecked={c.view} /></center></td>
                        <td><center><Checkbox onClick={this.handleChangeCheck('add', c.referId)} defaultChecked={c.add} /></center></td>
                        <td><center><Checkbox onClick={this.handleChangeCheck('edit', c.referId)} defaultChecked={c.edit} /></center></td>
                        <td><center><Checkbox onClick={this.handleChangeCheck('cancel', c.referId)} defaultChecked={c.cancel} /></center></td>
                        <td><center><Checkbox onClick={this.handleChangeCheck('exports', c.referId)} defaultChecked={c.exports} /></center></td>
                      </tr>
                    )
                  })
                }
              </table>
            </DialogContent>
            <DialogActions>
              { this.state.updateMenuControls.length != 0 ?
                (
                  <Button onClick={this.submit.bind(this)}>Submit</Button>
                ):''
              }
              <Button onClick={ () => { this.setState({ open: false }) } }>Close</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

View.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
